import { render, staticRenderFns } from "./IconSquare.vue?vue&type=template&id=4b4889f1&functional=true"
import script from "./IconSquare.vue?vue&type=script&lang=js"
export * from "./IconSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports